import { render } from "./Index.vue?vue&type=template&id=44f7de44&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=44f7de44&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44f7de44"

export default script